<div class="userlane-wrapper d-flex flex-column justify-content-center align-items-center" (click)="openUserlane()">
  <img src="../../../../assets/image/Guidance-icon.svg" class="userlane-icon" />
  <div>{{ 'Walkthrough' | translate }}</div>
</div>
